import { WebCloserName } from '../constants/misc';
import {
  useDealAdvisorsQuery,
  useGetOperatingHoursAndTimeSlotsQuery,
} from '../gql/generated/graphql';
import { DealWithFarthestState, computeEffectiveDealState } from '../pages/dashboard/utils';

export type LeaseExpertCloser = {
  id?: string | null;
  name?: string | null;
  photo_url?: string | null;
};

export type LeaseExpertOpts = {
  isPending: boolean;
  closer?: LeaseExpertCloser | null;
  isOpen: boolean;
};

const useLeaseExpertOpts = (deal: DealWithFarthestState): LeaseExpertOpts => {
  const { data: advisorsData } = useDealAdvisorsQuery({
    variables: { dealId: deal?.id },
    skip: !deal?.id || !deal?.closer_id,
    pollInterval: 120000,
  });

  const { data: operatingHoursData } = useGetOperatingHoursAndTimeSlotsQuery({
    fetchPolicy: 'cache-and-network',
  });

  const rawCloser = advisorsData?.dealAdvisors?.closer;
  const closer = rawCloser?.name === WebCloserName || !rawCloser?.id ? null : rawCloser;

  const isPending = computeEffectiveDealState(deal) < 2;
  const isOpen = operatingHoursData?.getOperatingHoursAndTimeSlots?.isOpen ?? false;

  return { isPending, closer, isOpen };
};

export default useLeaseExpertOpts;
